import React from 'react';

const EventsUpdates: React.FC = () => {
  const scrollToMailingList = () => {
    const mailingListSection = document.getElementById('mailing-list');
    if (mailingListSection) {
      mailingListSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="py-24 px-4 bg-gradient-to-br from-dance-cream to-dance-gold/5">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-dance-navy mb-6 tracking-wide">
            EVENTS & UPDATES
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-dance-gold to-dance-terracotta mx-auto mb-8"></div>
        </div>
        
        {/* April Popup Event Announcement */}
        <div className="bg-gradient-to-br from-dance-navy to-dance-navy/90 rounded-3xl p-8 md:p-12 shadow-2xl max-w-3xl mx-auto">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-br from-dance-gold to-dance-terracotta rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4 tracking-wide">
            Popup Event Coming in April
          </h3>
          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Date and location details coming soon. Sign up for our newsletter to be the first to know when we announce the details.
          </p>
          <button
            onClick={scrollToMailingList}
            className="bg-dance-gold text-dance-navy px-8 py-4 text-lg font-semibold tracking-wide hover:bg-dance-terracotta transition-all duration-300 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            NOTIFY ME WHEN DETAILS ARE ANNOUNCED
          </button>
        </div>
      </div>
    </section>
  );
};

export default EventsUpdates;

